import React, { useEffect, useState } from 'react';
import CssBaseline from '@material-ui/core/CssBaseline';
import Typography from '@material-ui/core/Typography';
import Grid from '@material-ui/core/Grid';
import Chip from '@material-ui/core/Chip';
import Container from '@material-ui/core/Container';
import { useStylesHed, useStylesSN } from '../../../St/comps/UseStyle';
import StocksForm from './customers-form';
import toast, { Toaster } from 'react-hot-toast';
import StocksAppBar from './customers-appBar';
import customerAPI from '../../../api/customer';
import useFormDataCRUD from '../../../components/Hooks/useEDSCURD';
import { defaultCustomer, GetItemFromOptions, payTypes, SyncLocalStorage } from '../../../services/global-services';
import { AppBar, Box, colors, Paper, Snackbar, Tab, Tabs } from '@material-ui/core';
import { insh as inshst } from '../../../Context/InshSt';
import GroupIcon from '@material-ui/icons/Group';
import { useStyleC } from '../../../Fronts/Menues/st/UseStyle';
import { style } from '../../../Fronts/Menues/st/cStyle';
import { useTranslation } from 'react-i18next';
import CustomersSubForm from './customers-sub-data-form';
// import { a11yProps, TabsPanel } from '../../bascDatas/Tab1/items/AddItems/ItemsMains';
import i18next from "i18next";
import ImportExcel from '../../bascDatas/Tab1/items/ImportExcel/ImportExcel';
import { uri } from '../../../help/Api';
import axios from 'axios';
import CustomersSearch from './CustomersSearch/CustomersSearch';
import { insh, sto } from '../../../Context/InshData';
import { Alert } from '@material-ui/lab';
// import AlertSnak from './AlertSnak';
function getItemFromOptions(id, options) {
  if (id && id != -1)
    return options.filter(g => g.id == id)[0];
  return '';
}
function TabPanel(props) {
  const { children, value, index, ...other } = props;

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`simple-tabpanel-${index}`}
      aria-labelledby={`simple-tab-${index}`}
      {...other}
      keepMounted
    >
      {value === index && (
        <Box >
          <Typography>{children}</Typography>
        </Box>
      )}
    </div>
  );
}

function a11yProps(index) {
  return {
    id: `simple-tab-${index}`,
    "aria-controls": `simple-tabpanel-${index}`,
  };
}
export default function Customers(props) {

  const { data, type, fetchURL, isDialog, defaultSalman, Levels } = props;
  const { t } = useTranslation(['translation', 'forms']);
  const [pricesLevels, setPricesLevels] = useState(() => {
    return [{ id: 0, name: "بدون" }, ...Levels ?? []];
  });


  const defaultValues = {
    ...defaultCustomer,
    acc_no: props.newAccount,
    type: type,
    CustandSup: type,
    act: data?.Acts[0],
  };
  const {
    onChange,
    submit,
    update,
    remove,
    submitting,
    errorMessage,
    onShow,
    onEnd,
    object,
    formType,

  } = useFormDataCRUD(
    customerAPI.create,
    customerAPI.update,
    customerAPI.remove,
    undefined,
    defaultValues,
    null,
    async () => {
      if (isDialog) {
        await SyncLocalStorage();
      } else fetchURL();
    },
  );


  const title = type == 1 ? t('forms:customer') : t('forms:customer');
  const title1 = type == 1 ? t('translation:cust-add') : t('translation:sup-add');
  const clashd = useStylesHed();
  const classes = useStyleC();
  const styheader =
    { textAlign: 'center', backgroundColor: "#faf1f1", direction: 'rtl' }
  const [value, setValue] = React.useState(0);
  const handleChange = (event, newValue) => {
    setValue(newValue);
  };
  const [excelData, setExcelData] = useState([]);
  const [loadingExcel, setLoadingExcel] = useState(false);
  const [isUpdate, setIsUpdate] = useState(false);

  const getFormExcelData = async () => {
    setLoadingExcel(true);
    const excelCustomers = excelData.map((sub, i) => {
      return {
        name: sub.الاسم !== null ? sub?.الاسم : null,
        tax_no: sub.الضريبة !== null ? sub?.الضريبة : null,
        phone: sub.الجوال !== null ? sub?.الجوال : null,
        address: sub.العنوان !== null ? sub?.العنوان : null,
        build: sub.المبنى !== null ? sub?.المبنى : null,
        add: sub.الإضافي !== null ? sub?.الإضافي : null,
        dist: sub.الحي !== null ? sub?.الحي : null,
        city: sub.المدينة !== null ? sub?.المدينة : null,
        cr_no: sub.السجل !== null ? sub?.السجل : null,
        streat: sub.الشارع !== null ? sub?.الشارع : null,
        credit: sub.الدين !== null ? sub?.الدين : null,
        type: type

      };
    });
    const model = {
      excelCust: excelCustomers,
      type: type,
      db_name: sto?.db_name,
    };
    axios
      .post(uri + "Groups/addExcelCustomers", model)
      .then((res) => {
        setExcelData([]);
        setLoadingExcel(false);
        toast.success(t("forms:save-success"));
        setValue(0);
      })
      .catch((error) => {
        console.log(error);
        setLoadingExcel(false);
        toast.error(t("forms:save-failed"));
      });
  };

  //---------------------

  const handCloseDw = () => {
    setValue(0);
  };
  const [dataSearch, setDataSearch] = useState([]);

  const onRowClick = (row) => {
    onShow({
      ...row,
      act: GetItemFromOptions(row.act, data?.Acts),
      Cust_inv_type: row?.Cust_inv_type ? GetItemFromOptions(row.Cust_inv_type, payTypes) : payTypes[0],
      salesmen: (row.salesmen && row.salesmen != 0) ? GetItemFromOptions(row.salesmen, data?.salesmen) : '',
      country: GetItemFromOptions(row.country, data?.Countries),
      city: GetItemFromOptions(row.city, data?.Cities),
      area: GetItemFromOptions(row.area, data?.Areas),
      level_price: GetItemFromOptions(row?.level_price ?? 0, pricesLevels),
    }, "edit");
    setValue(0);
    setIsUpdate(true);
  };
  let optionsUsers = props?.OptionsUsers;
  const perm = data?.permisElm;
  const styBtn = {
    dis: { color: "#3b773d", background: "#4fa152" },
    undis: { color: "#fff" },
  };
  const clasSN = useStylesSN();
  const [snack, setSnack] = React.useState(insh.Snack);
  const { vertical, horizontal, openSnak } = snack;
  const handOSnack = (newState) => {
    setSnack({ openSnak: true, ...newState });
  };
  const handCSnack = (event, reason) => {
    setSnack({ ...snack, openSnak: false });
  };

  const frontSnack = () => {
    return (
      <div className={clasSN.rootSN}>
        <Toaster />
        <Snackbar
          anchorOrigin={{ vertical, horizontal }}
          open={openSnak}
          autoHideDuration={snack.time}
          onClose={handCSnack}
          key={vertical + horizontal}
          style={{backgroundColor:snack?.color}}
          className={clasSN.snackbarSN}
        >
          <Alert onClose={handCSnack} severity={snack.severit}>
            {" "}
            {snack.text}{" "}
          </Alert>
        </Snackbar>
      </div>
    );
  };

  return (
    <div className={classes.root}>
      <Typography
        component="div"
        style={{ direction: i18next.language == "ar" ? "rtl" : "ltr" }}
      >
        <AppBar position="static" style={{ backgroundColor: "fff" }} >
          <Tabs
            style={{ backgroundColor: colors.red[100] }}
            value={value}
            onChange={handleChange}
            aria-label="simple tabs example"
          >
            <Tab style={{ fontWeight: "bold", color: "#000" }} label={
              formType == 'edit' ? (type == 1 ? t('forms:edit_cust_data') : t('forms:edit_supplier_data')) : title1
            }{...a11yProps(0)} />
            {!perm?.Se &&
              (
                <Tab style={{ fontWeight: "bold", color: "#000" }} label={type == 1 ? t("forms:customers-search") : t("forms:suppliers-search")}{...a11yProps(1)} />
              )}
            <Tab style={{ fontWeight: "bold", color: "#000" }} label={t("forms:import-excel")}{...a11yProps(2)} />
          </Tabs>
        </AppBar>

        <TabPanel value={value} index={0} keepMounted>

          <Typography component="div" style={styheader}>
            <Grid item container style={{ paddingBottom: "50px" }}>
              <Grid container
                justifyContent="space-around"
              >
                <Grid item lg={8} md={8} sm={12}>
                  <Container component={Paper} maxWidth={true}
                    style={{
                      padding: '15px',
                      // paddingRight:'0px',
                      // backgroundColor: colors.[50],
                      paddingTop: '0px',
                      borderColor: inshst.colors.cust,
                      borderTopWidth: '0px',
                      borderLeftWidth: '0px',
                      borderBottomWidth: '0px',
                      borderRightWidth: '10px',
                      borderStyle: 'solid'
                    }}

                  >
                    <Grid
                      container
                      justify="space-between"
                    >
                      <Grid item>
                        <Chip size="large" className={clashd.ChipHdCustomer} label={type == 1 ? t('forms:cust-data') : t('forms:sup-data')} />
                      </Grid>
                      <Grid item>
                        <GroupIcon className={classes.iconCard} style={style.color.customer} />
                      </Grid>
                    </Grid>

                    <StocksForm {...{
                      ...props,
                      onChange,
                      submit,
                      update,
                      remove,
                      submitting,
                      errorMessage,
                      onShow,
                      onEnd,
                      object,
                      formType,
                      type,
                      pricesLevels
                    }} />

                  </Container>
                </Grid>

                <Grid item lg={3} md={3} sm={12}>
                  <Container component={Paper} maxWidth={true}
                    style={{
                      padding: '10px',
                      paddingTop: '0px',
                      borderColor: inshst.colors.cust,
                      borderTopWidth: '0px',
                      borderLeftWidth: '0px',
                      borderBottomWidth: '0px',
                      borderRightWidth: '0px',
                      borderStyle: 'solid'
                    }}
                  >
                    <Grid
                      container
                      justify="center"
                      style={{ paddingBottom: '20px' }}
                    >
                      <Grid item>
                        <Chip size="large" className={clashd.ChipHdCustomer} label={t("forms:national-address-data")} />
                      </Grid>
                    </Grid>

                    <CustomersSubForm {...{
                      ...props,
                      onChange,
                      submit,
                      update,
                      remove,
                      submitting,
                      errorMessage,
                      onShow,
                      onEnd,
                      object,
                      formType,
                    }} />

                  </Container>
                </Grid>
              </Grid>
            </Grid>

          </Typography>


        </TabPanel>
        {!perm?.Se &&
          <TabPanel value={value} index={1} keepMounted>
            <CustomersSearch {...{
              ...props,
              handCloseDw,
              onRowClick,
              type,
              optionsUsers,
              dataSearch,
              setDataSearch,
            }} />
          </TabPanel>
        }

        <TabPanel value={value} index={perm?.Se ? 1 : 2} keepMounted>
          <ImportExcel
            {...{
              isPurches: false,
              isStock: false,
              isItem: true,
              getFormExcelData,
              excelData,
              setExcelData,
              loadingExcel,
              setValue
            }}
          />
        </TabPanel>
        <StocksAppBar {...{
          ...props,
          onChange,
          defaultValues,
          submit,
          update,
          remove,
          submitting,
          errorMessage,
          onShow,
          onEnd,
          object,
          formType,
          pricesLevels,
          toast,
          isUpdate,
          setIsUpdate,
          value,
          perm,
          handOSnack
        }} />
        {/* {frontSnack()} */}
        {/* <AlertSnak {...{
         openSnak, snack, handCSnack, vertical, horizontal
        }} /> */}
        {frontSnack()}
      </Typography>
    </div>
  );


}